import React from 'react';

const Bootstrap: React.FC = ({ children }) => {
  return <>{children}</>;
};

export default Bootstrap;
